export const ACCOMMODATION_TYPE_CATEGORY = 'CATEGORY';
export const ACCOMMODATION_TYPE_ROOM_TYPE = 'ROOM_TYPE';
export const ACCOMMODATION_TYPE_ROOMS = 'ROOMS';
export const ACCOMMODATION_TYPE_PACKAGES = 'PACKAGES';
export const ACCOMMODATION_TYPE_FLOOR = 'FLOOR';
export const ACCOMMODATION_TYPE_UPGRADES = 'UPGRADES';
export const ACCOMMODATION_TYPE_PERSONALISATION = 'PERSONALISATION';
export const ACCOMMODATION_TYPE_RATE_FILTERS = 'RATE_FILTERS';
export const ACCOMMODATION_TYPE_PREFERENCE = 'PREFERENCE';

export const CATEGORY_VIEW = 'category_view';
export const CATEGORY_CREATE = 'category_create';
export const CATEGORY_EDIT = 'category_edit';
export const ROOM_TYPE_VIEW = 'room_type_view';
export const ROOM_TYPE_CREATE = 'room_type_create';
export const ROOM_TYPE_EDIT = 'room_type_edit';
export const PACKAGE_VIEW = 'packagee_view';
export const PACKAGE_CREATE = 'package_create';
export const PACKAGE_EDIT = 'package_edit';
export const ROOM_CREATE = 'room_create';
export const ROOM_EDIT = 'room_edit';
export const ROOM_VIEW = 'room_view';
export const FLOOR_VIEW = 'floor_view';
export const FLOOR_CREATE = 'floor_create';
export const FLOOR_EDIT = 'floor_edit';
export const UPGRADE_VIEW = 'upgrade_view';
export const UPGRADE_CREATE = 'upgrade_create';
export const UPGRADE_EDIT = 'upgrade_edit';
export const PERSONALISATION_VIEW = 'personalisation_view';
export const PERSONALISATION_CREATE = 'personalisation_create';
export const PERSONALISATION_EDIT = 'personalisation_edit';
export const RATE_FILTERS_VIEW = 'rate_filters_view';
export const RATE_FILTERS_CREATE = 'rate_filters_create';
export const RATE_FILTERS_EDIT = 'rate_filters_edit';
export const PREFERENCE_VIEW = 'preference_view';
export const PREFERENCE_CREATE = 'preference_create';
export const PREFERENCE_EDIT = 'preference_edit';


export const RoomViews = ['Ocean View', 'Lake View', 'Bay View', 'Pool View'];
export const AreaSizeUnits = ['Sq. Feet', 'Sq. Meter'];
export const smokingPolicies = [
  { id: true, name: 'Allowed' },
  { id: false, name: 'Not Allowed' },
];

export const ROOM_TYPE_VIEW_TABS = ['Details', 'Features', 'Media'];

export const ROOM_FILTER_MENU = [
  { title: 'All', field: 'all', subMenu: [] },
  { title: 'Categories', field: 'categoryId', subMenu: [] },
  { title: 'Room Types', field: 'roomTypeId', subMenu: [] },
];
